import { KeyboardArrowDown } from "@mui/icons-material";

import AutoCompleteDropdown from "../../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import HNSColors from "../../../../../../ui library/HNSColors";
import { useProviderDetailStore } from "../../../store/provider-details/providerDetailStore";
import { STYLES } from "../../../utils/customStyles";

export default function CommPreferencesField({
  placeholder = "",
  fieldName,
  fieldValue,
  onChange,
}) {
  const { communicationPreferenceTypes } = useProviderDetailStore();
  const selectedOption = communicationPreferenceTypes.find(
    (option) => option.key === Number(fieldValue)
  );

  return (
    <AutoCompleteDropdown
      data={communicationPreferenceTypes}
      initValue={selectedOption}
      getOptionLabel={(option) => option?.label || ""}
      isOptionEqualToValue={(option, optionValue) =>
        option?.key === optionValue?.key || option === optionValue
      }
      renderTags={null}
      placeholder={placeholder}
      onValueChange={(_, value) => {
        onChange(fieldName, String(value.key));
      }}
      ListboxProps={{
        sx: {
          maxHeight: 200,
          overflow: "auto",
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: HNSColors.primary[500],
            borderRadius: "3px",
          },
        },
      }}
      textFieldSx={STYLES.textField}
      selectProps={{
        IconComponent: (props) => (
          <KeyboardArrowDown {...props} sx={{ fontSize: 24, color: HNSColors.primary[500] }} />
        ),
      }}
      dropdownSx={STYLES.selectMenuPaper}
    />
  );
}
